import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/bff/client';
import { IconGeneric } from '@spotahome/ui-library';

import './Paginator.scss';

const getLinkProps = (isButtonDisabled, pageUrl, role) => ({
  className: classNames('paginator--button', `paginator--button__${role}`, {
    'paginator--button__disabled': isButtonDisabled
  }),
  href: pageUrl
});

class Paginator extends PureComponent {
  static propTypes = {
    previousButtonDisabled: PropTypes.bool,
    nextButtonDisabled: PropTypes.bool,
    onPreviousButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func,
    previousPageUrl: PropTypes.string.isRequired,
    nextPageUrl: PropTypes.string.isRequired
  };

  static defaultProps = {
    previousButtonDisabled: false,
    nextButtonDisabled: false,
    onPreviousButtonClick: () => {},
    onNextButtonClick: () => {}
  };

  handlePreviousClick = e => {
    e && e.preventDefault();
    this.props.onPreviousButtonClick();
  };

  handleNextClick = e => {
    e && e.preventDefault();
    this.props.onNextButtonClick();
  };

  render() {
    const {
      previousButtonDisabled,
      nextButtonDisabled,
      previousPageUrl,
      nextPageUrl
    } = this.props;

    return (
      <div className="paginator">
        <a
          {...getLinkProps(previousButtonDisabled, previousPageUrl, 'prev')}
          onClick={this.handlePreviousClick}
          role="button"
          tabIndex={0}
        >
          <IconGeneric name="angle-left" /> {trans('paginator.label.prev')}
        </a>
        <a
          {...getLinkProps(nextButtonDisabled, nextPageUrl, 'next')}
          onClick={this.handleNextClick}
          role="button"
          tabIndex={0}
        >
          {trans('paginator.label.next')} <IconGeneric name="angle-right" />
        </a>
      </div>
    );
  }
}

export default Paginator;
